// extracted by mini-css-extract-plugin
module.exports = {"title":"BaseDialog_title__1ZYCp","payload":"BaseDialog_payload__2C3NY","actions":"BaseDialog_actions__2ndMh"};